/* import __COLOCATED_TEMPLATE__ from './invite-to-company-modal.hbs'; */
import { inject as service } from '@ember/service';
import LSGModalBase from "../lsg/lsg-modal-dialog-base";
import { handleFormErrorOrModal, setErrors, clearErrors } from 'sh-www/utils/handles-errors';
import { closeModal } from 'sh-www/utils/modal-controls';
import { SH_CUSTOM_ERROR_CODES, SH_ERROR_INDEX } from 'sh-www/utils/adapter-errors';

/**
 * All the possible invite custom error codes.
 *
 * @type {number[]}
 */
const INVITE_CUSTOM_ERROR_CODES = [
  SH_CUSTOM_ERROR_CODES.ERROR_CODE_INVITED_USER_ALREADY_PART_OF_TEAM,
  SH_CUSTOM_ERROR_CODES.ERROR_CODE_INVITED_USER_ALREADY_HAS_ACCOUNT,
  SH_CUSTOM_ERROR_CODES.ERROR_CODE_INVITED_USER_HAS_EXTERNAL_ACCOUNT,
];

/**
 * Valid form inputs for this form.
 *
 * @type {string[]}
 */
const FORM_INPUTS = [
  'email'
];

export default LSGModalBase.extend({
  /**
   * Register services
   */
  applicationStateManager: service('state-managers/application'),
  companyCommandService : service('commands/company-commands'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @param {Company}
     */
    company: null,

    /**
     * Call back with the invite that was created on success
     *
     * @param {Function}
     */
    handleSendInviteSuccess: () => (function(invite) {})
  },

  /**
   * @inheritDoc
   */
  stateDefaults: {
    /**
     * @type {Boolean}
     */
    isSendingInvite: false,

    /**
     * @type {String}   The email input by the user
     */
    updatedEmail: '',
  },

  /** @inheritDoc */
  init() {
    this._super(...arguments);
    this.set('errors', { });
  },

  actions: {
    closeModal() {
      closeModal(this);
    },

    /**
     * User clicked to send the invite.
     */
    onSendInviteClicked() {
      this.set('state.isSendingInvite', true);
      clearErrors(this);

      const email = this.get('state.updatedEmail');

      this.get('companyCommandService').inviteUserToCompany(
        this.get('model.company'),
        { email },
        [],
        false
      ).then(invite => {
        this.model.handleSendInviteSuccess?.(invite);
        closeModal(this);
      }).catch(e => {
        let errors = e.errors;
        if (!errors) {
          return;
        }

        if (INVITE_CUSTOM_ERROR_CODES.includes(errors[SH_ERROR_INDEX.CUSTOM_ERROR_CODE])) {
          setErrors(this, { email: errors[SH_ERROR_INDEX.CUSTOM_ERROR_BODY] }, FORM_INPUTS, false, true);
          return;
        }

        handleFormErrorOrModal(
          this,
          e,
          FORM_INPUTS,
          'There was an error inviting this email address. Please refresh and try again.',
          'onSendInviteClicked -- error inviting email to company for company id : ' + this.get('model.company.id'),
        );
      }).finally(() => this.set('state.isSendingInvite', false));
    },

    onInputEmail(text) {
      this.set('state.updatedEmail', text);
    },

    handleClose() {
      this.closeModal();
    },
  }
});
